import styled from 'styled-components';

const CardBody = styled.div`
  padding: 25px;
`;

CardBody.displayName = 'CardBody';

export default CardBody;
